import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormCheckboxField from 'modules/ui/editform/fields/EditFormCheckboxField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import { useParams, withRouter } from 'react-router';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import EditFormSeparatorField from 'modules/ui/editform/fields/EditFormSeparatorField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import MeasurementService from 'app/admin/measurement/service/MeasurementService';
import MeasurementEditService from 'app/admin/measurement/service/MeasurementEditService';
import OneClassSvmKernel from '../dto/OneClassSvmKernel';
import OneClassSvmGamma from '../dto/OneClassSvmGamma';
import OutlierDetectorType from '../dto/OutlierDetectorType';
import OutlierDetectorEditService from '../service/OutlierDetectorEditService';
import AutoEncoderOutlierDetectorEditService from '../service/AutoEncoderOutlierDetectorEditService';
import OneClassSvmModelEditService from '../service/OneClassSvmModelEditService';
import IsolationForestModelEditService from '../service/IsolationForestModelEditService';
import LocalOutlierFactorModelEditService from '../service/LocalOutlierFactorModelEditService';
import RuleBasedModelEditService from '../service/RuleBasedModelEditService';
import RuleBasedOutlierDetectorRuleEditDto from '../dto/RuleBasedOutlierDetectorRuleEditDto';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const blockClassName = 'rounded-8 border px-16 pt-10 pb-4 mb-16';
const blockTitleClassName = 'py-8';

const outlierDetectorService = type => {
	if (type === 'AutoEncoder') return AutoEncoderOutlierDetectorEditService;
	if (type === 'OneClassSvm') return OneClassSvmModelEditService;
	if (type === 'IsolationForest') return IsolationForestModelEditService;
	if (type === 'LocalOutlierFactor') return LocalOutlierFactorModelEditService;
	if (type === 'RuleBased') return RuleBasedModelEditService;
	return OutlierDetectorEditService;
};

const handleValue = (value, field, methods) => {
	if (value) {
		const { setValue } = methods;
		let arr = [];
		if (value) arr = value.split(',').map(Number);
		setValue(field.name.replace('_str', ''), arr);
	}
};

const handleMeasurementFields = (dto) => {
	return new Promise((resolve, reject) => {
		if (dto && dto.measurement) {
			MeasurementEditService.getData(dto.measurement).then(resp => {
				let values = [];
				for (let i = 0; i < resp.fields.length; i += 1)	values.push({ label: resp.fields[i].name, value: resp.fields[i].name });
				resolve(values);
			}).catch(e => reject(e));
		} else {
			resolve([]);
		}
	});
};

const config = data => {
	const form = {
		key: 'outlierDetectorEditForm',
		topic: 'outlierDetector',
		service: outlierDetectorService(data.type),
		defaultValue: () => outlierDetectorService(data.type).createByType(data.type),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'type',
					component: EditFormSelectField,
					type: 'enum',
					readOnly: true,
					items: Object.keys(OutlierDetectorType).map(key => {
						return { label: OutlierDetectorType[key], value: key };
					})
				},
				{
					key: 'version',
					component: EditFormTextField,
					type: 'number',
					required: true
				},
				...(data.type === 'AutoEncoder'
					? [
						{
							key: 'train_epochs',
							component: EditFormTextField,
							type: 'number',
							required: true
						},
						{
							key: 'train_batch_size',
							component: EditFormTextField,
							type: 'number',
							required: true
						},
						{
							key: 'encoder_dimensions_str',
							component: EditFormTextField,
							onChange: (value, field, methods) => { handleValue(value, field, methods) },
							mask: {
								mask: /^[0-9,]*$/
							}
						},
						{
							key: 'decoder_dimensions_str',
							component: EditFormTextField,
							onChange: (value, field, methods) => { handleValue(value, field, methods) },
							mask: {
								mask: /^[0-9,]*$/
							}
						}
					] : []),

				...(data.type === 'IsolationForest'
					? [
						{
							key: 'n_estimators',
							component: EditFormTextField,
							type: 'number',
							required: true
						},
						{
							key: 'contamination',
							component: EditFormTextField,
							type: 'number',
							required: true
						}
					] : []),

				...(data.type === 'LocalOutlierFactor'
					? [
						{
							key: 'n_neighbours',
							component: EditFormTextField,
							type: 'number',
							required: true
						},
						{
							key: 'contamination',
							component: EditFormTextField,
							type: 'number',
							required: true
						},
						{
							key: 'novelty',
							component: EditFormCheckboxField,
						}
					] : []),

				...(data.type === 'OneClassSvm'
					? [
						{
							key: 'nu',
							component: EditFormTextField,
							type: 'number',
							required: true
						},
						{
							key: 'kernel',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(OneClassSvmKernel).map(key => {
								return { label: OneClassSvmKernel[key], value: key };
							})
						},
						{
							key: 'gamma',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(OneClassSvmGamma).map(key => {
								return { label: OneClassSvmGamma[key], value: key };
							})
						},
					] : []),

				...(data.type === 'RuleBased'
					? [
						{
							key: 'measurement',
							component: EditFormSelectField,
							items: () => MeasurementService.getListSelection()
						},
						{
							key: 'rulesGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepRules',
									text: 'Rules',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'rules',
									component: EditFormGridComponent,
									defaultValue: () => new RuleBasedOutlierDetectorRuleEditDto(),
									fields: [
										{
											key: 'name',
											component: EditFormSelectField,
											type: 'enum',
											filterKey: 'measurement',
											items: dto => handleMeasurementFields(dto || initData)
										},
										{
											key: 'min_value',
											text: 'Min. value',
											component: EditFormTextField,
											type: 'number',
											required: true
										},
										{
											key: 'max_value',
											text: 'Max. value',
											component: EditFormTextField,
											type: 'number',
											required: true
										}
									]
								}
							]
						}

					] : [])


			];
			return fields;
		}
	};

	return form;
};

function OutlierDetectorEditForm() {
	const { id, type } = useParams();

	const myConfig = config({ id, type });

	console.log(type);

	return <EditFormPage config={myConfig} />;
}

export default withRouter(OutlierDetectorEditForm);
